import React from 'react'
import Typewriter from 'typewriter-effect';
import "./typewriter.scss";
import { com } from '../../data/MainData';

export default function Positions() {
  return (
    <div className='type'>
        <span className='tw_text'>I am</span>
        <div className='positions'>
        <Typewriter
              options={{
                strings:com.position,
                autoStart: true,
                loop: true,
                cursor: '',
                deleteSpeed: 50,
                delay:75,
              }}
            />
        </div>
      
    </div>
  )
}
